import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs/Observable";
import { Subject } from "rxjs/Subject";
// import "rxjs/add/operator/map";
@Injectable()
export class FutureOperationalHoursService {
  futureOHAction = new Subject();
  constructor(private router: Router, private httpClient: HttpClient) { }

  
  list(filter = ""): Observable<any> {
    if (filter) {
      filter = "?" + filter;
    }
    return this.httpClient.get<any>("site/future" + filter);
  }

  updateOperationalHours(futureOHform,id = ""): Observable<any> {
    return this.httpClient.post("update-operational-hours/"+id, futureOHform);
  }

  create(futureOHform): Observable<any> {
    return this.httpClient.post("site/future", futureOHform);
  }

  update(futureOHform): Observable<any> {
    let body = futureOHform;
    return this.httpClient.patch("site/future", body);
  }

  delete(id): Observable<any> {
    return this.httpClient.delete("site/future/" + id);
  }

  getAction(): Observable<any> {
    return this.futureOHAction.asObservable();
  }

  sendAction(action, data) {
    this.futureOHAction.next({ action: action, data: data })
  }

}



// WEBPACK FOOTER //
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/shared/services/future-operational-hours/future-operational-hours.service.ts